export const isUntouchedStudentOnboardingCard = (card) => {
    if (!card || card.source === 'derived-leaving') {
        return false
    }

    const listName = String(card.whichList || '').trim().toLowerCase()
    if (listName !== 'scheduling' && listName !== 'student') {
        return false
    }

    const tasks = Array.isArray(card.todoSubtasks) ? card.todoSubtasks : []
    return !tasks.some((task) => task?.subtaskCompleted === true)
}
